import React from "react";
import { Status } from "../../types/statusTypes";
import { getStatusDisplayText } from "../../helpers/statusMapper";

interface StatusProps {
  statusText: Status;
}

export default function StatusLabel({ statusText }: StatusProps) {
  return (
    <div className={`${statusText} w-75 d-inline-block rounded-1 text-center`}>
      {getStatusDisplayText(statusText)}
    </div>
  );
}
